import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useLang } from "@/i18n";

export default function FaqSection() {
  const { t } = useLang();
  const items = [1, 2, 3, 4, 5].map((i) => ({ q: t(`faq.q${i}`), a: t(`faq.a${i}`) }));
  return (
    <section className="max-w-3xl mx-auto px-5 lg:px-8 pb-24" data-testid="faq-section">
      <p className="text-xs font-semibold uppercase tracking-[0.25em] text-[#635BFF] text-center">{t("faq.eyebrow")}</p>
      <h2 className="font-display text-2xl sm:text-3xl font-bold tracking-tight text-[#0A2540] mt-3 text-center">
        {t("faq.title")}
      </h2>
      <Accordion type="single" collapsible className="mt-10 space-y-3">
        {items.map((it, i) => (
          <AccordionItem
            key={i}
            value={`item-${i}`}
            data-testid={`faq-item-${i}`}
            className="bg-white rounded-xl border border-[#E6EBF1] px-5 data-[state=open]:border-[#635BFF]/40 data-[state=open]:shadow-[0_8px_24px_rgba(99,91,255,0.08)]"
          >
            <AccordionTrigger className="text-sm font-semibold text-[#0A2540] hover:no-underline py-4">
              {it.q}
            </AccordionTrigger>
            <AccordionContent className="text-sm text-[#425466] leading-relaxed pb-4">
              {it.a}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </section>
  );
}
